<button class="dropdown-item"
        (click)="$event.preventDefault();openExportModal();">
  {{'context-menu.actions.export-item.btn' | translate}}
</button>
